// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jc-0";